<div class="section light-bg overflow-hidden pb-0">
    <img src="assets/img/about2.jpg" class="absolute-img" alt="img">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-4">
                <div class="sigma_box sigma_testimonial mb-0">
                    <div class="section-title text-left">
                        <p class="subtitle">06 --- Feedback</p>
                        <h4 class="title">Client Testimonials</h4>
                    </div>
                    <!-- <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="sigma_testimonial-slider">
                      
                        <div ngxSlickItem class="sigma_testimonial-inner" *ngFor="let item of testimonials">
                            <p>{{item.comment}}</p>
                            
                            <div class="sigma_testimonial-author" *ngFor="let author of getAuthor(item.author)">
                                <img [src]="author.image" [alt]="author.name">
                                <div class="sigma_testimonial-author-inner">
                                    <h6>{{author.name}}</h6>
                                    <cite class="custom-primary">{{author.post}}</cite>
                                </div>
                            </div>
                            
                        </div>
                        
                    </ngx-slick-carousel> -->
                </div>
            </div>
        </div>
    </div>
</div>